import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/userApi';
const mk = (name, fn) => createAsyncThunk(name, async (a, { rejectWithValue }) => {
  try { return (await fn(a)).data.data; } catch (e) { return rejectWithValue(e.response?.data?.message || 'Error'); }
});
export const fetchUsers  = mk('users/fetchAll', () => api.getUsers());
export const createUser  = mk('users/create',   dto => api.createUser(dto));
export const updateUser  = mk('users/update',   ({id,dto}) => api.updateUser(id, dto));
export const toggleStatus= mk('users/toggle',   id => api.toggleStatus(id));
const s = createSlice({ name: 'users', initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchUsers.pending, s => { s.loading = true; })
     .addCase(fetchUsers.fulfilled, (s,{payload}) => { s.loading = false; s.list = payload || []; })
     .addCase(fetchUsers.rejected, (s,{payload}) => { s.loading = false; s.error = payload; });
    b.addCase(createUser.fulfilled, (s,{payload}) => { s.list.push(payload); });
    b.addCase(updateUser.fulfilled, (s,{payload}) => { const i = s.list.findIndex(u=>u.id===payload.id); if(i>=0) s.list[i]=payload; });
    b.addCase(toggleStatus.fulfilled, (s,{payload}) => { const i = s.list.findIndex(u=>u.id===payload.id); if(i>=0) s.list[i]=payload; });
  }
});
export default s.reducer;
